import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Info from "@insite/mobius/Icons/Info";
import Link from "@insite/mobius/Link";
import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { typography } from "@tKgpco/theme/styleguide";
import React, { FC, useState } from "react";
import { css } from "styled-components";

interface OwnProps {}

type Props = OwnProps;

export interface CallForPriceStyles {
    text?: InjectableCss;
    textWrapper?: InjectableCss;
    tooltip?: TooltipPresentationProps;
    tooltiptext?: InjectableCss;
}

export const CallForPriceStyles: CallForPriceStyles = {
    textWrapper: {
        css: css`
            margin-top: 0.5rem;
            position: relative;
        `,
    },
    text: {
        css: css`
            font-size: 14px;
            font-weight: 600;
            color: #e6b23d;
            border: 2px solid #e6b23d;
            border-radius: 4px;
            padding: 4px 12px;
            display: inline-block;
            .cfp-msg span {
                color: #e6b23d !important;
            }
            :hover [data-test-selector="tooltiptext"] {
                visibility: visible;
            }
        `,
    },
    tooltiptext: {
        css: css`
            visibility: hidden;
            width: 220px;
            background: #b3b3b3;
            color: #fff;
            text-align: center;
            border-radius: 6px;
            padding: 5px;
            font-weight: 400;
            position: absolute;
            z-index: 1;
            bottom: 100%;
            left: 50%;
            margin-left: -50px;
            margin-bottom: 5px;
            &::after {
                content: "";
                position: absolute;
                top: 100%;
                left: 23%;
                margin-left: -6px;
                border-width: 6px;
                border-style: solid;
                border-color: #b3b3b3 transparent transparent transparent;
            }
            span {
                color: #0645ad !important;
            }
        `,
    },
};

const styles = CallForPriceStyles;

const CallForPrice: FC<Props> = () => {
    return (
        <StyledWrapper {...styles.textWrapper}>
            <StyledWrapper {...styles.text}>
                <Link href="/contact-us" className="cfp-msg">
                    {siteMessage("call_for_price")}
                </Link>
                <Typography {...styles.tooltiptext} data-test-selector="tooltiptext">
                    {siteMessage("call_for_price_Text")}
                    <Link href="/contact-us">Click here to Contact us</Link>.
                </Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default CallForPrice;
